import { IconAlertCircle } from '@developerz/ui';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { buttonClass } from './ui/Button';

// "Finish your donation" (arc 101 slice 11, plan doc 05) — one line per project
// this donor PAYS for and has attached nothing to.
//
// It is persistent, not a toast: the failure it names is a live subscription
// buying capacity that does not exist, which no amount of time fixes and which
// nothing else on the page would say. It clears the moment a box or a key is
// attached — a donor who deliberately gave only one of the two is finished, and
// nagging them for the other half would be wrong.

export type FinishDonationBannerProps = {
  /** Projects paid for with no live box and no live key (`unfinishedProjects`). */
  readonly projects: readonly string[];
  readonly onResume: (project: string) => void;
};

export function FinishDonationBanner(props: FinishDonationBannerProps): JSX.Element {
  return (
    <For each={props.projects}>
      {(project) => (
        <div class="alert alert--icon" role="alert">
          <IconAlertCircle />
          <p class="alert__title">{t('donations.finish_title')}</p>
          <p class="alert__desc">{t('donations.finish_desc', { project })}</p>
          <button
            type="button"
            class={`${buttonClass({ size: 'sm' })} alert__action`}
            onClick={() => props.onResume(project)}
          >
            {t('donations.finish_cta')}
          </button>
        </div>
      )}
    </For>
  );
}
